import { defaultMemoize } from 'reselect';

import { stringifyQuery } from './url';

const emptyFilters = {
  includeOutOfStock: true,
  aggs: false,
  collection: null,
  defaultFpls: null,
  section: null,
  subsection: null,
  sections: null,
  defaultProductCategoryIds: [],
  categoryTagIds: [],
  categoryIds: [],
  defaultCollectionId: null,
  excludeFpls: [],
  fpls: null,
  collectionIds: [],
  colorTagIds: [],
  fabricTagIds: [],
  optionSignatures: [],
  sort: null,
  warehouseId: null,
  defaultTagId: null,
  excludeTagIds: [],
  productTypeIds: [],
};

export function requestParamsToRequestKey(params) {
  const key = stringifyQuery(params);
  return key || 'all';
}

export function requestParamsToStoreKey(params) {
  const { page, size, aggs, aggregations, ...rest } = params;
  const key = stringifyQuery(rest);
  return key || 'all';
}

export function requestParamsToAggregationKey(params) {
  const { defaultCollectionId, defaultProductCategoryIds, fpls } = params;
  const key = stringifyQuery({
    defaultCollectionId,
    defaultProductCategoryIds,
    fpls,
  });
  return key || 'all';
}

export const filtersToRequestParams = defaultMemoize(function (filters) {
  filters = { ...emptyFilters, ...filters };
  const params = filters.categorized
    ? {
        aggregations: !!filters.aggs,
        includeOutOfStock: !!filters.includeOutOfStock,
      }
    : {
        aggs: !!filters.aggs,
        includeOutOfStock: !!filters.includeOutOfStock,
      };
  if (filters.page) {
    params.page = filters.page;
  }
  if (filters.size) {
    params.size = filters.size;
  }
  if (filters.defaultProductCategoryIds.length) {
    params.defaultProductCategoryIds = filters.defaultProductCategoryIds;
  }
  if (filters.categoryIds.length) {
    params.categoryIds = filters.categoryIds;
  }
  if (filters.categoryTagIds.length) {
    params.categoryTagIds = filters.categorized
      ? filters.categoryTagIds
      : filters.categoryTagIds.join(' ');
  }
  if (filters.defaultCollectionId) {
    params.defaultCollectionId = filters.defaultCollectionId;
  }
  if (filters.collectionIds.length) {
    params.collectionIds = filters.categorized
      ? filters.collectionIds
      : filters.collectionIds.join(' ');
  }
  if (filters.colorTagIds.length) {
    if (filters.categorized) {
      params.colorTagIds = filters.colorTagIds;
    } else {
      params.colorTagIds = filters.colorTagIds.join(' ');
    }
  }
  if (filters.fabricTagIds.length) {
    if (filters.categorized) {
      params.fabricTagIds = filters.fabricTagIds;
    } else {
      params.fabricTagIds = filters.fabricTagIds.join(' ');
    }
  }
  if (filters.excludeTagIds.length) {
    params.excludeTagIds = filters.categorized
      ? filters.excludeTagIds
      : filters.excludeTagIds.join(' ');
  }
  if (filters.productTypeIds.length) {
    params.productTypeIds = filters.categorized
      ? filters.productTypeIds
      : filters.productTypeIds.join(' ');
  }
  if (filters.optionSignatures.length) {
    params.optionSignatures = filters.categorized
      ? filters.optionSignatures
      : filters.optionSignatures.join(' ');
    params.includeOutOfStock = false;
  }
  if (filters.categorized) {
    if (filters.braSizes && filters.braSizes.length) {
      params.braSizes = filters.braSizes;
      params.includeOutOfStock = false;
    }
    if (filters.braletteSizes && filters.braletteSizes.length) {
      params.braletteSizes = filters.braletteSizes;
      params.includeOutOfStock = false;
    }
    if (filters.lingerieSizes && filters.lingerieSizes.length) {
      // Adding an empty string includes "one size" products in filtered results
      params.lingerieSizes = [...filters.lingerieSizes, ''];
      params.includeOutOfStock = false;
    }
    if (filters.undieSizes && filters.undieSizes.length) {
      params.undieSizes = filters.undieSizes;
      params.includeOutOfStock = false;
    }
    if (filters.masterProductIds && filters.masterProductIds.length) {
      params.masterProductIds = filters.masterProductIds;
    }
  }
  if (filters.sort) {
    params.sort = filters.sort;
  }
  // Intentional done after `sort` so we can override.
  if (filters.fpls) {
    params.fpls = filters.categorized ? [filters.fpls] : filters.fpls;
    // Allow the option to sort by 'Top Converters'
    if (filters.sort !== 'topconverters') {
      params.sort = 'fplAsc';
    }
  }
  if (filters.excludeFpls.length) {
    params.excludeFpls = filters.categorized
      ? filters.excludeFpls
      : filters.excludeFpls.join(' ');
  }
  if (filters.defaultTagId) {
    params.defaultTagId = filters.defaultTagId;
  }
  if (filters.warehouseId) {
    params.warehouseId = filters.warehouseId;
  }
  if (filters.dateExpectedMin) {
    params.dateExpectedMin = filters.dateExpectedMin;
  }
  if (filters.dateExpectedMax) {
    params.dateExpectedMax = filters.dateExpectedMax;
  }
  if (filters.availableQtyMin) {
    params.availableQtyMin = filters.availableQtyMin;
  }
  if (filters.groupBy) {
    params.groupBy = filters.groupBy;
  }
  if (filters.shouldUseSuggestedProductsAlgo) {
    params.shouldUseSuggestedProductsAlgo = true;
  }
  if (filters.isSet) {
    params.includeOutOfStock = true;
  }
  if (filters.includeSaleItems) {
    params.excludeFpls = [];
  }
  return params;
});
